exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer-payments .payment-img[data-v-74e9825f]{width:40px;height:35px;margin:2px;display:flex;align-items:center;justify-content:center}.footer-payments .payment-img img[data-v-74e9825f]{max-height:100%}", ""]);

// exports
